import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { KAL_DIALOG_DATA, KalDate, KalDialogRef } from '@kalidea/kaligraphi';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { FormValidator } from 'src/app/validators/form-validator';

export interface SharedDateSelectionDialogData {
    accepted?: boolean;
    selectedDate: KalDate;
    selectedDateLabel: string;
}

@Component({
    selector: 'app-shared-date-selection-dialog',
    templateUrl: './shared-date-selection-dialog.component.html',
    styleUrls: ['./shared-date-selection-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedDateSelectionDialogComponent extends BaseComponent implements OnInit {

    dateSelectedControl: UntypedFormControl;
    dateSelectedLabel = '';

    constructor(protected readonly cdr: ChangeDetectorRef,
                private readonly fb: UntypedFormBuilder,
                private readonly dialogRef: KalDialogRef<SharedDateSelectionDialogComponent>,
                @Inject(KAL_DIALOG_DATA) private readonly data: SharedDateSelectionDialogData) {
        super(cdr);
    }

    submit(): void {
        if (this.dateSelectedControl.invalid) {
            return;
        }

        this.dialogRef.close({
            accepted: true,
            selectedDate: this.dateSelectedControl.value
        });
    }

    close(): void {
        this.dialogRef.close({
            accepted: false
        });
    }

    ngOnInit(): void {
        this.dateSelectedLabel = this.data.selectedDateLabel;
        this.dateSelectedControl = new UntypedFormControl(
            this.data.selectedDate || null,
            {validators: [FormValidator.isNotNull, FormValidator.date]}
        );
    }
}
